<style>
label {
    font-weight: 600;
}
</style>
<h2 style="padding:25px;">
    IP: {{ clientIP }} <br>
    Location Lat:  {{ clientLat }} 
    Location Long:  {{ clientLong }} 
    <br>
    Browser : {{ clientBrowser }}
</h2>
<div class="m-content" id="page-signup" style="display:none;">
    <div class="header">
        <div class="container">
            <a routerLink="/login" class="m-brand__logo-wrapper">
                <img alt="" src="assets/demo/demo2/media/img/logo/01.png" style="height:60px" />
            </a>
        </div>
    </div>
    <br>
    <br>
    <div class="container">
        <div class="m-portlet" style="min-height:450px">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <span class="m-portlet__head-icon"><i class="flaticon-map-location"></i></span>
                        <h3 class="m-portlet__head-text">Register</h3>
                    </div>
                </div>
                <div class="pull-right" style="margin-top:20px">
                    <a class="btn btn-secondary m-btn m-btn--icon m-btn--pill btn-sm" href="#" ng-reflect-href="#">
                        <span><span>Cancle</span></span>
                    </a>
                </div>
            </div>

            <div class="m-portlet__body" *ngIf="!showThankYou">
            <form (ngSubmit)="f.form.valid && addPartner()" #f="ngForm" action="">

                <b>Your Information :</b><br><br>
                <div class="row">
                    <div class="col-md-4 form-group1 m-form__group">
                        <label>PAN</label>
                        <input type="text" required class="form-control m-input" name="panNumber" #panNumber="ngModel" [(ngModel)]="partnerCreate.panNumber" maxlength="10"
                                minlength="10" pattern="[A-Za-z]{5}\d{4}[A-Za-z]{1}" Partner Type />
                    </div>
                    <div class="col-md-4  col-sm-12 form-group1 m-form__group">
                        <label>Mobile</label>
                        <input type="text" required class="form-control m-input" name="mobile" #mobile="ngModel" [(ngModel)]="partnerCreate.mobile" pattern="[0-9]*"
                        minlength="10" maxlength="10" autocomplete="off" />
                    </div>
                    <div class="col-md-4 col-sm-12 form-group1 m-form__group">
                        <label>Email</label>
                        <input type="email" required class="form-control m-input" name="email" #email="ngModel" [(ngModel)]="partnerCreate.email" minlength="5" maxlength="50"
                        autocomplete="off" />
                    </div>
                </div><br>

                <div class="row">
                    <div class="col-md-4 col-sm-12 form-group1 m-form__group">
                        <label>First Name</label>
                        <input type="text" required class="form-control m-input" name="firstName" #firstName="ngModel" [(ngModel)]="partnerCreate.firstName"
                            autocomplete="off" />
                    </div>
                    <div class="col-md-4 col-sm-12 form-group1 m-form__group">
                        <label>Last Name</label>
                        <input type="text" required class="form-control m-input" name="lastName" #lastName="ngModel" [(ngModel)]="partnerCreate.lastName"
                            autocomplete="off" />
                    </div>
                </div>
                <br>
                <!-- <div class="m-separator m-separator--dashed m-separator--lg"></div> -->
                <!-- <b>Buisness Information : <br></b> -->
                <!-- <br>
                <div class="row">
                    <div class="col-md-4 form-group1 m-form__group">
                        <label>Buisness Name</label>
                        <input type="text" required class="form-control m-input" name="partnerName" #email="ngModel" [(ngModel)]="partnerCreate.partnerName"
                        autocomplete="off" />
                    </div>
                    
                    <div class="col-md-4 form-group1 m-form__group">
                        <label>GSTIN</label>
                        <input type="text" required class="form-control m-input" name="gstNumber" #gstNumber="ngModel" [(ngModel)]="partnerCreate.gstNumber" minlength="15"
                               maxlength="15" />
                    </div>
                </div> -->

                <div class="m-separator m-separator--dashed m-separator--lg"></div>
                <b>KYC Documents : <br></b>
                <div class="row">
                <div class="col-md-12">
                    <div class="m-portlet__body">
                    <!-- <div class="form-group m-form__group">
                        <h6>
                        Upload KYC Documents*
                        </h6>
                    </div> -->
                    <div class="m-widget4" style="padding-left:25px;padding-right:25px">
        
                        <div class="m-widget4__item" style="width:100%;padding-top: 15px;padding-bottom: 15px;" *ngFor="let document of kycDocTypeList;let i=index">
        
                        <div class="m-widget4__info pull-left" style="margin-top: 5px;width: 50%;">
                            <span class="m-widget4__text">
                            {{document}}
                            </span>
                        </div>
                        
                        <div class="m-widget4__ext file-upload text-right" *ngIf='kycDocUploadedList.indexOf(document) == -1'>
                            <input type="file" accept=".png,.pdf,.jpeg,.jpg" id="{{document}}" name="{{document}}" (change)="addSelectedDoc($event)" docsrc="" autocomplete="off" style="display:none" />
                            <label for="{{document}}" class="upload-icon">
                            <span><img src="../../../assets/documents/UploadImg.png" style="cursor:pointer;"></span></label>
                        </div>

                        <span *ngIf='kycDocUploadedList.indexOf(document) > -1'>
                        <div class="m-widget4__ext file-upload text-right" style="display:block;">
                            <a class="m-widget4__icon" style="margin-left:10px;cursor: pointer;" (click)="deleteDocument(kycDocUploadedList.indexOf(document))">
                                <i class="la la-trash"></i>
                            </a>
                        </div>
                        </span>

                        </div>
                    </div>
                    </div>
                </div>
                </div>

                <div class="row">
                <div class="col-md-12 form-group1 m-form__group text-center" style="padding-top:30px;">
                    <button class="btn btn-primary" id="m_partner" [disabled]='proceedToRegisterBt' type="submit">
                        Proceed
                    </button>
                </div>
                </div>
                <!--
                    <div class="row">
                    <div class="col-md-12 form-group1 m-form__group">
                        <div class="m-widget4" style="padding-left:25px;padding-right:25px">
                            <div class="m-widget4__item" style="width:100%;padding-top: 15px;padding-bottom: 15px;">
                                <div class="m-widget4__info pull-left" style="margin-top: 5px;">
                                    <span class="m-widget4__text">Aadhaar</span>
                                </div>
                                <div class="m-widget4__ext file-upload text-right">
                                    <input type="file" autocomplete="off" style="display:none" />
                                    <label class="upload-icon"><span><img src="../../../assets/documents/UploadImg.png" style="width:20px"></span></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 form-group1 m-form__group">
                        <div class="m-widget4" style="padding-left:25px;padding-right:25px">
                            <div class="m-widget4__item" style="width:100%;padding-top: 15px;padding-bottom: 15px;">
                                <div class="m-widget4__info pull-left" style="margin-top: 5px;">
                                    <span class="m-widget4__text">Pan</span>
                                </div>
                                <div class="m-widget4__ext file-upload text-right">
                                    <input type="file" autocomplete="off" style="display:none" />
                                    <label class="upload-icon"><span><img src="../../../assets/documents/UploadImg.png" style="width:20px"></span></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 form-group1 m-form__group">
                        <button class="btn btn-primary" type="submit">
                            Submit
                        </button>
                    </div>
                    </div>
                -->
            </form>
            </div>

            <div *ngIf="showThankYou" class="thankYouMessage">
                <h2>Thank you registration we will get back to you soon.</h2>
            </div>

        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/signup/signup.component.html